import licenseModule from '../license.module';
import angular from 'angular';

export default licenseModule.factory('LicenseManagementService', [
    '$q',
    '$timeout',
    '__env',
    'jwtHelper',
    'accountService',
    'alertLevelConstants',
    'alertNotificationConstants',
    'textResources',
    'licenseLevelConstants',
    LicenseManagementService
]);

function LicenseManagementService(
    $q,
    $timeout,
    __env,
    jwtHelper,
    accountService,
    alertLevelConstants,
    alertNotificationConstants,
    textResources,
    licenseLevelConstants
) {
    function getInstances() {
        var defer = $q.defer();
        accountService.getLicenseTypes().then(function(licenseTypeResponse) {
            accountService.getInstances().then(function(instances) {
                var views = [];

                for (var index in instances) {
                    var instance = instances[index];
                    var status = snakeCase(instance.status);
                    if (instance.type.toLowerCase() == 'cloud') {
                        status = 'Active';
                        instance.communicationStatus = 'Ok';
                    } else if (status == 'pending') {
                        status = snakeCase(instance.pendingStatus);
                    } else {
                        if (
                            instance.allocationType.toLowerCase() == 'dynamic'
                        ) {
                            if (
                                instance.communicationStatus.toLowerCase() !=
                                    'undefined' &&
                                instance.communicationStatus.toLowerCase() ==
                                    'ok'
                            ) {
                                status = snakeCase(
                                    instance.communicationStatus
                                );
                            }
                        }
                    }

                    var instanceUserLicenseTypes = [];
                    var instanceDeviceLicenseTypes = [];

                    populateInstanceLicenseTypes(
                        instance,
                        licenseTypeResponse,
                        instanceUserLicenseTypes,
                        instanceDeviceLicenseTypes
                    );

                    var view = {
                        id: instance.id,
                        name: instance.name,
                        serverDescription: instance.description,
                        instanceType: snakeCase(instance.type),
                        allocationType: snakeCase(instance.allocationType),
                        country: instance.country,
                        countryCode: instance.countryCode,
                        online:
                            instance.communicationStatus.toLowerCase() ==
                                'undefined' ||
                            instance.communicationStatus.toLowerCase() == 'ok',
                        lastSync: new Date(instance.lastSync),
                        expireDate:
                            instance.endDate !== undefined
                                ? new Date(instance.endDate)
                                : undefined,
                        status: status,
                        usage: {
                            deviceId:
                                instance.allocated.totalIds.usage !== undefined
                                    ? instance.allocated.totalIds.usage
                                          .deviceIds
                                    : 0,
                            premiumUserId:
                                instance.allocated.totalIds.usage !== undefined
                                    ? instance.allocated.totalIds.usage
                                          .premiumIds
                                    : 0
                        },
                        allocated: {
                            subscription: {
                                deviceId:
                                    instance.allocated.totalIds.subscription
                                        .deviceIds,
                                premiumUserId:
                                    instance.allocated.totalIds.subscription
                                        .premiumIds
                            },
                            perpetual: {
                                deviceId:
                                    instance.allocated.totalIds.perpetual !==
                                    undefined
                                        ? instance.allocated.totalIds.perpetual
                                              .deviceIds
                                        : 0,
                                premiumUserId:
                                    instance.allocated.totalIds.perpetual !==
                                    undefined
                                        ? instance.allocated.totalIds.perpetual
                                              .premiumIds
                                        : 0
                            }
                        },
                        licenseStatus: snakeCase(instance.licenseStatus),
                        deploymentType: instance.deploymentType,
                        version: instance.version,
                        userLicenseTypes: instanceUserLicenseTypes,
                        deviceLicenseTypes: instanceDeviceLicenseTypes
                    };
                    views.push(view);
                }
                defer.resolve(views);
            });
        }, defer.reject);

        return defer.promise;
    }

    function decodeServerProfile(payload) {
        var defer = $q.defer();
        var serverDetails = {};

        if (payload !== undefined) {
            try {
                payload = payload.trim();
                var regexNewLineChar = /\\r\\n/g;
                var regexNewLine = /\s\n/g;
                var regexNewLine2 = /\n/g;
                var regexMarker = /([-]*[\s\w]+[-]+\r?\n?)([\w]+=*\r?\n?)([-]*[\s\w]+[-]+\r?\n?)/g;
                payload = payload.replace(regexNewLineChar, '');
                payload = payload.replace(regexNewLine, '');
                payload = payload.replace(regexNewLine2, '');

                var arrayRegex = regexMarker.exec(payload);

                var payloadBase64 = arrayRegex[2];
                var jwtToken = new Buffer(
                    payloadBase64.toString().trim(),
                    'base64'
                );

                var decodedobj = jwtHelper.decodeToken(jwtToken.toString());

                serverDetails.name = decodedobj.server.hostname;
                serverDetails.serverProfile = [
                    {
                        no: 1,
                        attribute: 'Appspace Version',
                        value: decodedobj.appspace.version
                    },
                    {
                        no: 2,
                        attribute: 'IP / Host Value',
                        value: decodedobj.server.ip
                    },
                    {
                        no: 3,
                        attribute: 'MAC Address',
                        value: decodedobj.server.mac
                    },
                    {
                        no: 4,
                        attribute: 'CPU Id',
                        value: decodedobj.server.processorId
                    },
                    {
                        no: 5,
                        attribute: 'Motherboard Serial Number',
                        value: decodedobj.server.motherboardId
                    }
                ];
            } catch (err) {
                defer.reject(serverDetails);
            }
        }
        $timeout(function() {}, 750).then(function() {
            defer.resolve(serverDetails);
        });
        return defer.promise;
    }

    function createInstance(license) {
        var defer = $q.defer();
        var instanceRequest = {
            name: license.server.name,
            description: license.server.description,
            countryCode: license.server.countryCode,
            type: 2,
            allocationType: 1,
            allocation: {
                subscription: {
                    deviceIds: license.subscription.maxDevices,
                    premiumIds: license.subscription.maxUsers
                },
                perpetual: {
                    deviceIds: license.perpetual.maxDevices,
                    premiumIds: license.perpetual.maxUsers
                }
            },
            serverProfile: {
                payload: license.server.payload
            }
        };

        accountService.createInstance(instanceRequest).then(
            function(data) {
                return defer.resolve(data);
            },
            function(data) {
                return defer.reject(data);
            }
        );
        return defer.promise;
    }

    function generateLicense(license) {
        var defer = $q.defer();
        var instanceRequest = {
            name: license.server.name,
            description: license.server.description,
            countryCode: license.server.countryCode,
            type: 2,
            allocationType: 1,
            allocation: {
                subscription: {
                    deviceIds: license.subscription.maxDevices,
                    premiumIds: license.subscription.maxUsers
                },
                perpetual: {
                    deviceIds: license.perpetual.maxDevices,
                    premiumIds: license.perpetual.maxUsers
                }
            },
            serverProfile: {
                payload: license.server.payload
            }
        };

        accountService.createInstance(instanceRequest).then(
            function(data) {
                accountService.getInstanceActivation(data.id).then(
                    function(data) {
                        accountService.get64CharPayload(data.payload).then(
                            function(payload) {
                                return defer.resolve(payload);
                            },
                            function() {
                                return defer.reject();
                            }
                        );
                    },
                    function() {
                        return defer.reject();
                    }
                );
            },
            function() {
                return defer.reject();
            }
        );
        return defer.promise;
    }

    function getPlanInfoSummary() {
        var defer = $q.defer();
        var promises = [];

        promises.push(accountService.getSubscriptionEntitlement());
        promises.push(accountService.getPlanInformation());

        $q.all(promises).then(function(results) {
            var entitlementResponse = results[0];
            var planInformationResponse = results[1];

            var planView = {
                plan: planInformationResponse.name,
                startDate: new Date(planInformationResponse.startDate),
                endDate: new Date(planInformationResponse.endDate),
                planStatus: planInformationResponse.status.toLowerCase(),
                planDescription: planInformationResponse.description,
                cloudStorageTotal: entitlementResponse.cloudStorage,
                cloudBandwidthTotal: entitlementResponse.cloudBandwidth,
                totalDeviceId: entitlementResponse.ids.subscription.deviceIds,
                totalPremiumUserId:
                    entitlementResponse.ids.subscription.premiumIds,
                hasOnPrem: planInformationResponse.createInstance,
                hasPerpetual: false,
                planType: planInformationResponse.type.toLowerCase()
            };

            if (
                entitlementResponse.ids.perpetual.deviceIds > 0 ||
                entitlementResponse.ids.perpetual.premiumIds > 0
            ) {
                planView.hasPerpetual = true;
            } else {
                planView.hasPerpetual = false;
            }

            var planInfoSummary = require('./licenseOverviewService.planInfoSummary.mock');
            planView = angular.merge({}, planInfoSummary, planView);

            defer.resolve(planView);
        });
        return defer.promise;
    }

    function getAppspaceIDSummary() {
        var defer = $q.defer();
        var promises = [];

        promises.push(accountService.getTotalUsage());
        promises.push(accountService.getSubscriptionEntitlement());
        promises.push(accountService.getPlanInformation());
        promises.push(this.getInstances());
        promises.push(accountService.getLicenseTypes());

        $q.all(promises).then(function(results) {
            var usageResponse = results[0];
            var entitlementResponse = results[1];
            var planInformation = results[2];
            var instancesInformation = results[3];
            var licenseTypeResponse = results[4];

            var hasStaticAllocation = false;
            var hasOlderVersion = false;
            if (instancesInformation && instancesInformation.length > 0) {
                var staticAllocations = instancesInformation.filter(x => {
                    return x.allocationType.toLowerCase() == 'static';
                });
                if (staticAllocations && staticAllocations.length > 0) {
                    hasStaticAllocation = true;
                }

                var instancesWithOlderVersions = instancesInformation.filter(
                    x =>
                        !x.version ||
                        (x.version &&
                            x.version.includes('.') &&
                            parseInt(
                                x.version.substr(0, x.version.indexOf('.'))
                            ) < 7)
                );

                if (instancesWithOlderVersions.length > 0) {
                    hasOlderVersion = true;
                }
            }

            var globalUserLicenseTypes = [];
            var globalDeviceLicenseTypes = [];

            populateGlobalLicenseType(
                entitlementResponse,
                usageResponse,
                licenseTypeResponse,
                hasStaticAllocation,
                globalUserLicenseTypes,
                globalDeviceLicenseTypes
            );

            var view = {
                plan: planInformation.name,
                startDate: planInformation.startDate,
                endDate: planInformation.endDate,
                type: planInformation.type,
                hasOlderVersion: hasOlderVersion,
                hasStaticAllocation: hasStaticAllocation,
                subscription: {
                    deviceId: {
                        usage: usageResponse.totalIds.subscription.deviceIds,
                        total: entitlementResponse.ids.subscription.deviceIds
                    },
                    premiumUserId: {
                        usage: usageResponse.totalIds.subscription.premiumIds,
                        total: entitlementResponse.ids.subscription.premiumIds
                    }
                },
                perpetual: {
                    deviceId: {
                        usage: usageResponse.totalIds.perpetual.deviceIds,
                        total: entitlementResponse.ids.perpetual.deviceIds
                    },
                    premiumUserId: {
                        usage: usageResponse.totalIds.perpetual.premiumIds,
                        total: entitlementResponse.ids.perpetual.premiumIds
                    }
                },
                usage: {
                    deviceId: {
                        usage: usageResponse.totalIds.usage.deviceIds
                    },
                    premiumUserId: {
                        usage: usageResponse.totalIds.usage.premiumIds
                    }
                },
                device: {
                    alertLevel:
                        usageResponse.device && usageResponse.device.alertLevel
                            ? usageResponse.device.alertLevel
                            : alertLevelConstants.none
                },
                platformUser: {
                    alertLevel:
                        usageResponse.platformUser &&
                        usageResponse.platformUser.alertLevel
                            ? usageResponse.platformUser.alertLevel
                            : alertLevelConstants.none
                },
                storage: {
                    alertLevel:
                        usageResponse.storage &&
                        usageResponse.storage.alertLevel
                            ? usageResponse.storage.alertLevel
                            : alertLevelConstants.none
                },
                bandwidthDetail: {
                    alertLevel:
                        usageResponse.bandwidthDetail &&
                        usageResponse.bandwidthDetail.alertLevel
                            ? usageResponse.bandwidthDetail.alertLevel
                            : alertLevelConstants.none,
                    usage: usageResponse.bandwidthDetail
                        ? usageResponse.bandwidthDetail.usage
                        : null
                },
                userLicenseTypes: globalUserLicenseTypes,
                deviceLicenseTypes: globalDeviceLicenseTypes
            };

            var warningMessages = [];
            var criticalMessages = [];

            switch (view.device.alertLevel) {
                case alertLevelConstants.critical:
                    criticalMessages.push(textResources.usageDeviceCritical);
                    break;
                case alertLevelConstants.hazard:
                case alertLevelConstants.warning:
                    warningMessages.push(textResources.usageDeviceWarning);
                    break;
            }

            switch (view.platformUser.alertLevel) {
                case alertLevelConstants.critical:
                    criticalMessages.push(
                        textResources.usagePlatformUsersCritical
                    );
                    break;
                case alertLevelConstants.hazard:
                case alertLevelConstants.warning:
                    warningMessages.push(
                        textResources.usagePlatformUsersWarning
                    );
                    break;
            }

            switch (view.storage.alertLevel) {
                case alertLevelConstants.critical:
                    criticalMessages.push(textResources.usageStorageCritical);
                    break;
                case alertLevelConstants.hazard:
                case alertLevelConstants.warning:
                    warningMessages.push(textResources.usageStorageWarning);
                    break;
            }

            switch (view.bandwidthDetail.alertLevel) {
                case alertLevelConstants.critical:
                    if (
                        view.bandwidthDetail.usage ==
                        entitlementResponse.cloudBandwidth
                    ) {
                        criticalMessages.push(
                            textResources.usageBandwidthCritical
                        );
                    } else {
                        criticalMessages.push(
                            textResources.usageBandwidthExceeded
                        );
                    }
                    break;
                case alertLevelConstants.hazard:
                case alertLevelConstants.warning:
                    warningMessages.push(textResources.usageBandwidthWarning);
                    break;
            }

            var alertNotifications = [];
            alertNotifications = addAlertNotification(
                alertNotifications,
                criticalMessages,
                alertNotificationConstants.error
            );
            alertNotifications = addAlertNotification(
                alertNotifications,
                warningMessages,
                alertNotificationConstants.warning
            );

            view.alertNotifications = alertNotifications;

            // If plan is expired, check for the perpetual entitlement and set the flag hasPerpetual
            if (planInformation.type.toLowerCase() == 'legacy') {
                if (
                    entitlementResponse.ids.perpetual.deviceIds > 0 ||
                    entitlementResponse.ids.perpetual.premiumIds > 0
                ) {
                    view.perpetual.deviceId.usage +=
                        view.subscription.deviceId.usage;
                    view.perpetual.premiumUserId.usage +=
                        view.subscription.premiumUserId.usage;

                    view.subscription.deviceId.usage = 0;
                    view.subscription.deviceId.total = 0;
                    view.subscription.premiumUserId.usage = 0;
                    view.subscription.premiumUserId.total = 0;
                }
            } else if (
                (planInformation.status.toLowerCase() == 'inactive' ||
                    planInformation.status.toLowerCase() == 'restricted') &&
                planInformation.type.toLowerCase() != 'free'
            ) {
                if (
                    entitlementResponse.ids.perpetual.deviceIds > 0 ||
                    entitlementResponse.ids.perpetual.premiumIds > 0
                ) {
                    view.subscription.deviceId.usage = 0;
                    view.subscription.deviceId.total = 0;
                    view.subscription.premiumUserId.usage = 0;
                    view.subscription.premiumUserId.total = 0;
                }
            }
            var appspaceIdSummary = require('./licenseManagementService.appspaceIdSummary.mock');
            view = angular.merge({}, appspaceIdSummary, view);
            defer.resolve(view);
        }, defer.reject);

        return defer.promise;
    }

    var SNAKE_CASE_REGEXP = /[A-Z]/g;

    function snakeCase(name) {
        if (name !== undefined && name !== '') {
            var separator = '-';
            return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }
        return name;
    }

    function addAlertNotification(alertNotifications, messages, type) {
        if (messages && messages.length > 0) {
            alertNotifications.push({
                messages: messages,
                type: type
            });
        }
        return alertNotifications;
    }

    function applyReceipt(instanceGuid, receipt) {
        var defer = $q.defer();
        accountService.applyReceipt(instanceGuid, receipt).then(
            function() {
                return defer.resolve();
            },
            function() {
                return defer.reject();
            }
        );
        return defer.promise;
    }

    function getInstanceActivation(instanceGuid) {
        return accountService.getInstanceActivation(instanceGuid);
    }

    function get64CharPayload(payload) {
        return accountService.get64CharPayload(payload);
    }

    function manageInstanceAllocation(instanceGuid, license) {
        var defer = $q.defer();
        var manageAllocationRequest = {
            subscription: {
                deviceIds: license.subscription.maxDevices,
                premiumIds: license.subscription.maxUsers
            },
            perpetual: {
                deviceIds: license.perpetual.maxDevices,
                premiumIds: license.perpetual.maxUsers
            }
        };

        accountService
            .manageInstanceAllocation(instanceGuid, manageAllocationRequest)
            .then(
                function(data) {
                    accountService.getInstanceActivation(data.id).then(
                        function(data) {
                            accountService.get64CharPayload(data.payload).then(
                                function(payload) {
                                    return defer.resolve(payload);
                                },
                                function() {
                                    return defer.reject();
                                }
                            );
                        },
                        function() {
                            return defer.reject();
                        }
                    );
                },
                function() {
                    return defer.reject();
                }
            );
        return defer.promise;
    }

    function getInstanceDetail(instanceGuid) {
        return accountService.getInstanceDetail(instanceGuid);
    }

    function updateInstance(instanceGuid, instance) {
        var defer = $q.defer();
        var instanceRequest = {
            name: instance.name,
            description: instance.description,
            country: instance.country,
            countryCode: instance.countryCode,
            type: 2,
            allocationType: 1,
            serverProfile: {
                payload: instance.payload
            }
        };
        accountService.updateInstance(instanceGuid, instanceRequest).then(
            function(data) {
                return defer.resolve(data);
            },
            function() {
                return defer.reject();
            }
        );
        return defer.promise;
    }

    function renewInstance(instanceGuid, instance) {
        var defer = $q.defer();
        var instanceRequest = {
            name: instance.name,
            description: instance.serverDescription,
            country: instance.country,
            type: 2,
            allocationType: 1,
            serverProfile: {
                payload: instance.serverProfile
            }
        };

        accountService.updateInstance(instanceGuid, instanceRequest).then(
            function(data) {
                accountService.getInstanceActivation(data.id).then(
                    function(data) {
                        accountService.get64CharPayload(data.payload).then(
                            function(payload) {
                                return defer.resolve(payload);
                            },
                            function() {
                                return defer.reject();
                            }
                        );
                    },
                    function() {
                        return defer.reject();
                    }
                );
            },
            function() {
                return defer.reject();
            }
        );
        return defer.promise;
    }

    function deactivateInstanceActivation(instanceGuid) {
        var defer = $q.defer();
        accountService.deleteInstanceActivation(instanceGuid).then(
            function(data) {
                accountService.getInstanceActivation(data.id).then(
                    function(data) {
                        accountService.get64CharPayload(data.payload).then(
                            function(payload) {
                                return defer.resolve(payload);
                            },
                            function() {
                                return defer.reject();
                            }
                        );
                    },
                    function() {
                        return defer.reject();
                    }
                );
            },
            function() {
                return defer.reject();
            }
        );
        return defer.promise;
    }

    function populateInstanceLicenseTypes(
        instance,
        licenseTypeResponse,
        instanceUserLicenseTypes,
        instanceDeviceLicenseTypes
    ) {
        var userLegacy = {
            name: 'Users (Legacy)',
            showStaticAllocation:
                instance.allocationType.toLowerCase() == 'static',
            legacy: true,
            level: licenseLevelConstants.user.name,
            usage:
                instance.allocated.totalIds.usage !== undefined
                    ? instance.allocated.totalIds.usage.premiumIds
                    : 0,
            allocated: {
                subscription:
                    instance.allocated.totalIds.subscription.premiumIds,
                perpetual:
                    instance.allocated.totalIds.perpetual !== undefined
                        ? instance.allocated.totalIds.perpetual.premiumIds
                        : 0
            }
        };

        instanceUserLicenseTypes.push(userLegacy);

        var deviceLegacy = {
            name: 'Devices (Legacy)',
            showStaticAllocation:
                instance.allocationType.toLowerCase() == 'static',
            legacy: true,
            level: licenseLevelConstants.device.name,
            usage:
                instance.allocated.totalIds.usage !== undefined
                    ? instance.allocated.totalIds.usage.deviceIds
                    : 0,
            allocated: {
                subscription:
                    instance.allocated.totalIds.subscription.deviceIds,
                perpetual:
                    instance.allocated.totalIds.perpetual !== undefined
                        ? instance.allocated.totalIds.perpetual.deviceIds
                        : 0
            }
        };

        instanceDeviceLicenseTypes.push(deviceLegacy);

        for (var i = 0; i < licenseTypeResponse.items.length; i++) {
            if (
                instance.allocated.totalIds.subscription[
                    'license.' + licenseTypeResponse.items[i].id
                ]
            ) {
                var licenseType = {
                    name: licenseTypeResponse.items[i].name,
                    level:
                        licenseTypeResponse.items[i].level.toLowerCase() ===
                        licenseLevelConstants.user.name.toLowerCase()
                            ? licenseLevelConstants.user.name
                            : licenseLevelConstants.device.name,
                    instanceUsage:
                        instance.allocated.totalIds.subscription[
                            'license.' + licenseTypeResponse.items[i].id
                        ],
                    usage:
                        instance.allocated.totalIds.usage[
                            'license.' + licenseTypeResponse.items[i].id
                        ] !== undefined
                            ? instance.allocated.totalIds.usage[
                                  'license.' + licenseTypeResponse.items[i].id
                              ]
                            : 0,
                    allocated: {
                        subscription:
                            instance.allocated.totalIds.subscription[
                                'license.' + licenseTypeResponse.items[i].id
                            ],
                        perpetual:
                            instance.allocated.totalIds.perpetual !== undefined
                                ? instance.allocated.totalIds.perpetual
                                      .deviceIds
                                : 0
                    },

                    showStaticAllocation:
                        instance.allocationType.toLowerCase() == 'static'
                };

                if (
                    licenseType.level.toLowerCase() ===
                    licenseLevelConstants.user.name.toLowerCase()
                ) {
                    instanceUserLicenseTypes.push(licenseType);
                } else if (
                    licenseType.level.toLowerCase() ===
                    licenseLevelConstants.device.name.toLowerCase()
                ) {
                    instanceDeviceLicenseTypes.push(licenseType);
                }
            }
        }
    }

    function populateGlobalLicenseType(
        entitlementResponse,
        usageResponse,
        licenseTypeResponse,
        hasStaticAllocation,
        globalUserLicenseTypes,
        globalDeviceLicenseTypes
    ) {
        var userLegacy = {
            name: 'Users (Legacy)',
            showStaticAllocation: hasStaticAllocation,
            legacy: true,
            level: licenseLevelConstants.user.name,
            subscription: {
                usage: usageResponse.totalIds.subscription.premiumIds,
                total: entitlementResponse.ids.subscription.premiumIds
            },
            perpetual: {
                usage: usageResponse.totalIds.perpetual.premiumIds,
                total: entitlementResponse.ids.perpetual.premiumIds
            },
            usage: usageResponse.totalIds.usage.premiumIds,
            alertLevel:
                usageResponse.platformUser &&
                usageResponse.platformUser.alertLevel
                    ? usageResponse.platformUser.alertLevel
                    : alertLevelConstants.none
        };

        globalUserLicenseTypes.push(userLegacy);

        var deviceLegacy = {
            name: 'Devices (Legacy)',
            showStaticAllocation: hasStaticAllocation,
            legacy: true,
            level: licenseLevelConstants.device.name,
            subscription: {
                usage: usageResponse.totalIds.subscription.deviceIds,
                total: entitlementResponse.ids.subscription.deviceIds
            },
            perpetual: {
                usage: usageResponse.totalIds.perpetual.deviceIds,
                total: entitlementResponse.ids.perpetual.deviceIds
            },
            usage: usageResponse.totalIds.usage.deviceIds,
            alertLevel:
                usageResponse.device && usageResponse.device.alertLevel
                    ? usageResponse.device.alertLevel
                    : alertLevelConstants.none
        };

        globalDeviceLicenseTypes.push(deviceLegacy);

        for (var i = 0; i < licenseTypeResponse.items.length; i++) {
            if (
                entitlementResponse.ids.subscription[
                    'license.' + licenseTypeResponse.items[i].id
                ]
            ) {
                var licenseType = {
                    name: licenseTypeResponse.items[i].name,
                    level:
                        licenseTypeResponse.items[i].level.toLowerCase() ===
                        licenseLevelConstants.user.name.toLowerCase()
                            ? licenseLevelConstants.user.name
                            : licenseLevelConstants.device.name,
                    showStaticAllocation: hasStaticAllocation,
                    legacy: false,
                    subscription: {
                        usage:
                            usageResponse.totalIds.subscription[
                                'license.' + licenseTypeResponse.items[i].id
                            ],
                        total:
                            entitlementResponse.ids.subscription[
                                'license.' + licenseTypeResponse.items[i].id
                            ]
                    },
                    perpetual: {
                        usage:
                            usageResponse.totalIds.perpetual[
                                'license.' + licenseTypeResponse.items[i].id
                            ],
                        total:
                            entitlementResponse.ids.perpetual[
                                'license.' + licenseTypeResponse.items[i].id
                            ]
                    },
                    usage:
                        usageResponse.totalIds.usage[
                            'license.' + licenseTypeResponse.items[i].id
                        ]
                };

                if (
                    licenseType.level.toLowerCase() ===
                    licenseLevelConstants.user.name.toLowerCase()
                ) {
                    globalUserLicenseTypes.push(licenseType);
                } else if (
                    licenseType.level.toLowerCase() ===
                    licenseLevelConstants.device.name.toLowerCase()
                ) {
                    globalDeviceLicenseTypes.push(licenseType);
                }
            }
        }
    }

    return {
        getInstances: getInstances,
        getAppspaceIDSummary: getAppspaceIDSummary,
        decodeServerProfile: decodeServerProfile,
        createInstance: createInstance,
        generateLicense: generateLicense,
        getPlanInfoSummary: getPlanInfoSummary,
        applyReceipt: applyReceipt,
        getInstanceActivation: getInstanceActivation,
        get64CharPayload: get64CharPayload,
        manageInstanceAllocation: manageInstanceAllocation,
        getInstanceDetail: getInstanceDetail,
        updateInstance: updateInstance,
        renewInstance: renewInstance,
        deactivateInstanceActivation: deactivateInstanceActivation
    };
}



// WEBPACK FOOTER //
// ./modules/license/services/licenseManagementService.service.js